import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {AuthProvider}  from './component/context/UserContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <BrowserRouter >
     <AuthProvider>
          <ToastContainer />

        <App />
    </AuthProvider>
    </BrowserRouter>
  // </React.StrictMode>
);
